// extracted by mini-css-extract-plugin
export default {"menu":"Main_menu__QvZKc","meuItem":"Main_meuItem__VJcSW"};